import { render, staticRenderFns } from "./_ID_PASSPORT_FRONT.vue?vue&type=template&id=b60d713e&"
import script from "./_ID_PASSPORT_FRONT.vue?vue&type=script&lang=js&"
export * from "./_ID_PASSPORT_FRONT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports